import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { PatchBuyer, ReadBuyer } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PatchBuyerParams {
  buyerId: string;
  data: PatchBuyer;
}

export const patchBuyer = async (
  params: PatchBuyerParams,
): Promise<ReadBuyer> => {
  return await tinctApi.buyers.patchBuyer(params.buyerId, params.data);
};

export const usePatchBuyer = (
  options?: Omit<
    UseMutationOptions<ReadBuyer, ApiError, PatchBuyerParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchBuyer,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['buyers'],
      });
      queryClient.invalidateQueries({
        queryKey: ['buyer', args[1].buyerId],
      });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
